import * as types from './mutationTypes';

export default {
  updateSpaces({ commit }, spaces) {
    Object.keys(spaces).forEach((spaceName) => {
      commit(types.SET_SPACE, {
        [spaceName]: spaces[spaceName],
      });
    });
    return true;
  },
  resetSpaces({ commit }) {
    commit(types.RESET_SPACE);
  },
};
